module.exports = __WEBPACK_EXTERNAL_MODULE_core_Misc_dataStorage__;